import { Text } from '@/components/ui/text'
import type { Tables } from '@hvf/contracts'
import { Divider, Flex, Grid } from 'styled-system/jsx'

export default function Description(props: { setup: Tables<'setup'> }) {

  return (
    <Grid gap='10px'>
      <Flex alignItems='center' gap='11px'>
        <Text
          color='editorialInk3'
          fontSize='11px'
          fontWeight='600'
          letterSpacing='.16em'
          textTransform='uppercase'
          flexShrink={0}
        >
          DETAILS
        </Text>
        <Divider borderColor='var(--colors-editorial-hair)' />
      </Flex>

      <Text
        whiteSpace='pre-wrap'
        fontSize='13.5px'
        lineHeight='1.6'
        color='editorialInk2'
      >
        {props.setup.description}
      </Text>

    </Grid>
  )
}
